(() => {
  function init(root = document) {
    root.querySelectorAll('.desktop-nav details').forEach(menu => {
      if (menu.dataset.hoverReady) return;
      menu.dataset.hoverReady = 'true';
      let timer;
      menu.addEventListener('pointerenter', e => {
        if (e.pointerType !== 'mouse' || !matchMedia('(hover: hover)').matches) return;
        clearTimeout(timer);
        root.querySelectorAll('.desktop-nav details[open]').forEach(other => { if (other !== menu) other.open = false; });
        menu.open = true;
      });
      menu.addEventListener('pointerleave', () => { timer = setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 180); });
      menu.addEventListener('focusout', () => { setTimeout(() => { if (!menu.contains(document.activeElement) && !menu.matches(':hover')) menu.open = false; }, 0); });
      menu.addEventListener('keydown', e => { if (e.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
    });
    root.querySelectorAll('[data-sd-search]').forEach(box => {
      if (box.dataset.ready) return;
      box.dataset.ready = 'true';
      const input = box.querySelector('[data-search-input]'), panel = box.querySelector('[data-search-results]'), clear = box.querySelector('[data-search-clear]'), status = box.querySelector('[data-search-status]');
      let timer, controller, revision = 0, active = -1;
      const close = () => { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; };
      const open = () => { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); };
      input.addEventListener('input', () => {
        clearTimeout(timer); if (controller) controller.abort();
        const id = ++revision, query = input.value.trim(); clear.hidden = !query; close();
        if (query.length < 2) { panel.innerHTML = ''; return; }
        timer = setTimeout(async () => {
          controller = new AbortController();
          try {
            const url = new URL(box.dataset.searchUrl, location.origin);
            url.searchParams.set('q', query); url.searchParams.set('type', 'product'); url.searchParams.set('options[prefix]', 'last'); url.searchParams.set('section_id', 'sd-search-suggestions');
            const response = await fetch(url, { signal: controller.signal });
            if (!response.ok) throw new Error('Search unavailable');
            const html = await response.text(); if (id !== revision) return;
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const section = parsed.querySelector('.shopify-section') || parsed.body;
            if (!section.querySelector('[data-result-count]')) return;
            panel.innerHTML = section.innerHTML;
            const list = panel.querySelector('[role="listbox"]');
            if (list) { list.id = panel.id + '-list'; input.setAttribute('aria-controls', list.id); }
            if (document.activeElement === input) open();
            status.textContent = panel.querySelector('[data-result-count]').textContent;
          } catch (error) { if (error.name !== 'AbortError' && id === revision) close(); }
        }, 250);
      });
      clear.addEventListener('click', () => { input.value = ''; input.dispatchEvent(new Event('input')); input.focus(); });
      input.addEventListener('focus', () => { if (input.value.trim().length > 1 && panel.querySelector('[data-result-count]')) open(); });
      input.addEventListener('keydown', e => {
        if (e.key === 'Escape') { close(); return; }
        if (panel.hidden) return;
        const items = [...panel.querySelectorAll('[role="option"]')].filter(x => x.querySelector('a'));
        if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && items.length) {
          e.preventDefault(); active = (active + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
          items.forEach((item, i) => item.setAttribute('aria-selected', String(i === active)));
          input.setAttribute('aria-activedescendant', items[active].id); items[active].scrollIntoView({ block: 'nearest' });
        } else if (e.key === 'Enter' && active >= 0 && items[active]) { e.preventDefault(); items[active].querySelector('a').click(); }
      });
      document.addEventListener('click', e => { if (!box.contains(e.target)) close(); });
      box.addEventListener('focusout', () => setTimeout(() => { if (!box.contains(document.activeElement)) close(); }, 0));
    });
  }
  init(); document.addEventListener('shopify:section:load', e => init(e.target));
})();
